/**
 * A credit figure as people read it: thousands separated, up to two decimal
 * places and no trailing zeros. $100 of program value is one credit, so a
 * program costs 68.8 credits and an enterprise bank holds 25,000.
 *
 * @param credits - The figure.
 * @returns "68.8", "1,250", "25,000".
 */
export function formatCredits(credits: number): string {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(credits);
}
